export default function PricingCTA() {
    return (
        <div className="pricingCTASection">
            <div className="pricingCTAContent">
                <h2 className="pricingCTATitle">Having trouble deciding?</h2>
                <p className="pricingCTADescription">Schedule a meeting to discuss your companies needs and talk options!</p>
                <a href='https://calendly.com/kyczar-kykustoms/30min' target='_blank' rel='noreferrer' className="pricingCTAButton">Schedule a Meeting</a>
            </div>
        </div>
    );
}